import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/css/App.css';
import 'lib/axiosSetup';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import AuthLayout from 'layouts/auth';
import UserLayout from 'layouts/user';
import DocumentLayout from 'layouts/document';
import ReservationLayout from 'layouts/reservation';
import { ChakraProvider } from '@chakra-ui/react';
import theme from 'theme/theme';
import { ThemeEditorProvider } from '@hypertheme-editor/chakra-ui';
import PrivateRoute from 'lib/PrivateRoute';
import PublicRoute from 'lib/PublicRoute';
import PrivacyPolicy from 'views/auth/privacy-policy';
import PayRedirect from 'views/pay';
import PaymentLayout from 'layouts/payment';

ReactDOM.render(
	<ChakraProvider theme={theme}>
		<React.StrictMode>
			<ThemeEditorProvider>
				<BrowserRouter>
					<Switch>
						<Route path='/privacy-policy' component={PrivacyPolicy} />
					<Route path='/pay/:code' component={PayRedirect} />
					<Route path='/payment' component={PaymentLayout} />
						<PublicRoute path={`/auth`} component={AuthLayout} />
						<PrivateRoute path={`/user`} component={UserLayout} />
						<Route path='/document' component={DocumentLayout} />
					<Route path='/reservation' component={ReservationLayout} />
						<Redirect from='/' to='/auth' />
					</Switch>
				</BrowserRouter>
			</ThemeEditorProvider>
		</React.StrictMode>
	</ChakraProvider>,
	document.getElementById('root')
);
